module.exports = __webpack_public_path__ + "img/security-audit-img-3.221d0fbe.webp";